import { french } from './lang/fr'

document.addEventListener('turbolinks:load', async function () {
  // When clicking on Edit Image in Create a Post Modal
  $(document).on('click', '.edit-media', function () {
    // If #imgly__editor-container doesn't exist, create it
    if (!$('#imgly__editor-container').length) {
      $('body').append('<div id="imgly__editor-container"></div>')
    }

    const image_element = $(this).siblings('img')
    const image_url = image_element.data('url')
    const input_element = $(this).siblings('input')

    setupPE(image_url, image_element, input_element)
  })
})

function setupPE (image_url, image_element, input_element) {
  (async () => {
    const { PhotoEditorSDKUI } = await import('photoeditorsdk')
    const license = process.env.IMGLY_LICENSE
    // All scripts have loaded
    PhotoEditorSDKUI.init({
      container: '#imgly__editor-container',
      // Please replace this with your license: https://img.ly/dashboard
      license,
      image: image_url,
      assetBaseUrl: '/assets',
      language: 'fr',
      theme: 'light',
      tools: [
        'transform', 'adjustment', 'text', 'textdesign'
      ],
      custom: {
        themes: {
          light: {
            primary: '#00b7ff',
            typography: {
              fontFamily: 'Avenir',
              skipLoading: true
            }
          }
        },
        languages: {
          fr: french
        }
      },
      export: {
        image: {
          enableDownload: false,
          format: 'image/jpeg',
          exportType: 'data-url'
        }
      }
    }).then((editor) => {
      editor.on('export', async (image) => {
        $.ajax({
          type: 'POST',
          url: '/imgly_override',
          data: {
            image
          },
          success: function (result) {
            image_element.on('load', function () {
              editor.close()

              mediaErrors()
            })

            if (image_element != undefined) {
              image_element.attr('src', result.thumbnail)
              image_element.attr('data-url', result.url)
            }

            if (input_element != undefined) {
              const tab_name = $(input_element).closest('.tab-pane').attr('id').replace('tab-', '')
              input_element.attr('name', 'create_post[' + tab_name + '][imgly_id][]')
              input_element.attr('value', result.id)
              if (tab_name == 'generic') {
                syncTab(tab_name)
              } else {
                setPreviewOfPost()
                unsyncTab(tab_name)
              }
            }
          },
          error: function (error) {
            console.log(error)
          }
        })
      })
    })
  })()
}
